var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, override } from 'mobx';
import { AnsweringFeedback } from '../../../classes/question/modules/AnsweringFeedback';
export class MultipleChoiceAnsweringFeedback extends AnsweringFeedback {
    constructor(init) {
        super(init);
        makeObservable(this);
    }
    get question() {
        return this.parent;
    }
    get feedbackText() {
        const isMultiple = this.question.choiceInfo.hasMultipleCorrectOptions;
        if (this.question.answeringState.isInFeedbackState) {
            return isMultiple ? this.feedbackTextFeedbackMultiple : this.feedbackTextFeedbackSingle;
        }
        return isMultiple ? this.feedbackTextAnsweringMultiple : this.feedbackTextAnsweringSingle;
    }
    get feedbackTextAnsweringSingle() {
        return '';
    }
    get feedbackTextFeedbackSingle() {
        if (this.question.answeringState.wasAnsweredFullyCorrect) {
            return 'Die Antwort ist korrekt.';
        }
        return 'Die Antwort ist leider falsch.';
    }
    get feedbackTime() {
        if (this.question.questionScore.reachedPoints === this.question.questionScore.maxPoints) {
            return super.feedbackTime;
        }
        return super.feedbackTime + 3000; // Longer Feedback in case of false answer
    }
    get feedbackTextAnsweringMultiple() {
        if (this.question.choiceEval.selectedOptions.length > 0) {
            return 'Eine weitere Antwortoption ist richtig.';
        }
        return '';
    }
    get feedbackTextFeedbackMultiple() {
        return 'Alle richtigen Antworten sind grün markiert.';
    }
}
__decorate([
    override
], MultipleChoiceAnsweringFeedback.prototype, "feedbackText", null);
